// @ts-strict-ignore
import Link from 'next/link';
import styled, { css } from 'styled-components';
import { truncate } from 'underscore.string';
import { useDispatch, useSelector } from 'src/store/store';
import { noMessageUsers } from 'src/constants/noMessageUsers';
import { unmuteUser } from 'src/modules/user/profile/actions';
import { closeModal, showModal } from 'src/modules/shared/modal/actions';
import { ModalType } from 'src/constants/modalTypes';
import { resendVerificationLink } from 'src/modules/shared/context/actions';
import { ffNewChatStart } from 'src/modules/messages/footfall';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import Button from 'src/components/buttons/button';
import { PrimaryButton } from 'styles-js/buttons';
export default function ProfileButtonNewChat() {
  const dispatch = useDispatch();
  const {
    currentUser,
    showVerificationBar
  } = useSelector(({
    context
  }) => context);
  const {
    profileUser
  } = useSelector(({
    pages
  }) => pages.profile);
  const {
    isDeceased,
    isMuted,
    userId,
    username
  } = profileUser;
  const noMessageUser = noMessageUsers.includes(userId);
  const onUnmuteClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'unmute-user',
      clickMetadata: {
        section: Section.ProfileHeader
      }
    });
    dispatch(unmuteUser(currentUser?.userId, userId));
  };
  const onResendEmailClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'resend-email',
      clickMetadata: {
        section: Section.EmailConfirmationModal,
        origin: 'profile-other'
      }
    });
    dispatch(resendVerificationLink());
    dispatch(closeModal());
  };
  const showUnverifiedPrompt = () => {
    const unverifiedEmail = truncate(currentUser?.unverifiedEmail || '', 40);
    trackFootfallEvent(Event.Clicked, {
      clickType: 'message-user-unverified',
      clickMetadata: {
        section: Section.ProfileHeader
      }
    });
    dispatch(showModal({
      modalType: ModalType.EmailConfirmation,
      modalProps: {
        unverifiedEmail,
        onResendEmailClick,
        title: i18n.t('Please verify your email address'),
        children: <>
            <p>{i18n.t('Only verified members can send messages to other members.')}</p>
            <p>{i18n.t('Please click the link we sent to ')}<b>{unverifiedEmail}</b>.</p>
          </>
      }
    }));
  };
  const onMessageClick = () => ffNewChatStart('profile');
  if (isDeceased || noMessageUser) return null;
  if (isMuted) {
    return <StyledButton dataTestId="profile__unmute_button" onClick={onUnmuteClick}>
        {i18n.t('Unmute')}
      </StyledButton>;
  }
  if (showVerificationBar) {
    return <StyledButton dataTestId="profile__message_button" onClick={showUnverifiedPrompt}>
        {i18n.t('Chat')}
      </StyledButton>;
  }
  return <Link legacyBehavior passHref as={`/messages/compose/${username}`} href={`/messages/thread?username=${username}&footfallSection=profile`} data-sentry-element="Link" data-sentry-component="ProfileButtonNewChat" data-sentry-source-file="profileButtonNewChat.tsx">
      <StyledLink as="a" data-testid="profile__message_button" onClick={onMessageClick} data-sentry-element="StyledLink" data-sentry-source-file="profileButtonNewChat.tsx">
        {i18n.t('Chat')}
      </StyledLink>
    </Link>;
}
const buttonStyles = css`
  margin: 5px 0;
  width: 110px;
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    width: auto;
    margin: 5px 5px 5px 0;
  }
`;
const StyledButton = styled(Button)`
  ${buttonStyles};
`;
const StyledLink = styled(PrimaryButton)`
  ${buttonStyles};
`;